import { generateReportReasonsQueryOptions } from '@/hooks/settings/use-report-reasons';
import type { ConversationType } from '@/models/conversations/conversation-session';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

interface Props {
  type: ConversationType;
}

export const reportLoader =
  ({ type }: Props) =>
  () => ({
    promises: queryClient.ensureQueryData(generateReportReasonsQueryOptions(type)).catch(catchFetcherError),
  });
